import { createActions, handleActions } from 'redux-actions'

const defaultState = {
  error: null,
  data: null,
  isLoading: true,
  isLoadingMore: false,
}

export const {
  fetchLoginToConfigurationStart,
  fetchLoginToConfigurationSuccess,
  fetchLoginToConfigurationFail,
  loginToConfigurationReset
} = createActions({
  FETCH_LOGIN_TO_CONFIGURATION_START: (mss) => ({mss}),
  FETCH_LOGIN_TO_CONFIGURATION_SUCCESS: loginToConfiguration => ({ loginToConfiguration }),
  FETCH_LOGIN_TO_CONFIGURATION_FAIL: error => ({ error }),
  LOGIN_TO_CONFIGURATION_RESET: () => ({})
})

export const loginToConfiguration = handleActions(
  {
    [loginToConfigurationReset]: (state) => {
      return { ...defaultState }
    },
    [fetchLoginToConfigurationStart]: state => ({
      ...state,
      error: null,
      isLoading: true
    }),
    [fetchLoginToConfigurationSuccess]: (state, { payload: { loginToConfiguration } }) => ({
      error: null,
      isLoading: false,
      data: loginToConfiguration
    }),
    [fetchLoginToConfigurationFail]: (state, { payload: {error} }) => ({
      error,
      isLoading: false,
      data: []
    })
  },
  defaultState
)
